var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDetail)?_c('b-card',[_c('header-detail',{attrs:{"detail":_vm.detail}}),_c('body-detail',{attrs:{"detail":_vm.detail,"notVersion":'true'},on:{"updateForm":_vm.goToDetail}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }